import type { Category } from '@@partner:types:app'
import type {
  CommonSort,
  NestedFilter,
  CommonPager,
  PageInfo
} from '@@partner:types:graphql'

import { gql, useQuery } from '@apollo/client'
import { SHORTCUT_PAGE_INFO_FIELDS } from '@@partner:graphql/shortcuts'

export interface CategoriesQueryResult {
  categories: {
    edges: Category[]
    pageInfo: PageInfo
  }
}

export interface CategoriesQueryVariables {
  filter?: NestedFilter
  sort?: CommonSort
  pager: CommonPager
}

export const GQL_QUERY_CATEGORIES = gql`

  query (
    $filter: NestedFilterInput
    $pager: CommonPagerInput
    $sort: CommonSortInput
  ) {
    categories: allCategories(
      filter: $filter
      sort: $sort
      pager: $pager
    ) {
    # categories(filter: $filter, sort: $sort, _page: $page, _limit: $limit) {
      edges {
        id
        name
        status
        icon {
          url
        }
        altIcon {
          url
        }

        parent {
          id
          name
        }
      }
      pageInfo {
        ${SHORTCUT_PAGE_INFO_FIELDS}
      }
    }
  }
`

export const useFetchCategories = (variables: CategoriesQueryVariables, skip = false) =>
  useQuery<CategoriesQueryResult, CategoriesQueryVariables>(
    GQL_QUERY_CATEGORIES,
    {
      variables,
      fetchPolicy: 'cache-and-network',
      skip
    }
  )
